import { StateSchema } from 'app/config/storeConfig/types';

export const getActiveStepIndex = (state: StateSchema): number => state.stepperModal.activeStepIndex;
